export function chosen() {
  return {
    restrict: 'EA',
    link: function (scope, element, attrs) {
      // update the select when data is loaded
      console.log( window.innerWidth)
      if( window.innerWidth >= 768 ){
        scope.$watch(attrs.chosen, function () {
          element.trigger('chosen:updated');
        });

        // update the select when the model changes
        scope.$watch(attrs.ngModel, function () {
          element.trigger('chosen:updated');
        });

        element.chosen();
      } else {
        $(element).removeClass('chosen');
      }
    }
  };
}


// WEBPACK FOOTER //
// ./~/@abosol/theme/src/app/directives/chosen.ts